import React  from 'react';

import Root from './root';
import './App.css';

const App: React.FC = (props) => {
    return (
        <Root />
    );
};

export default App;
